import { render, staticRenderFns } from "./expert-dialog.vue?vue&type=template&id=9c7e0da0&scoped=true"
import script from "./expert-dialog.vue?vue&type=script&lang=js"
export * from "./expert-dialog.vue?vue&type=script&lang=js"
import style0 from "./expert-dialog.vue?vue&type=style&index=0&id=9c7e0da0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c7e0da0",
  null
  
)

export default component.exports